import { defineComponent as _defineComponent } from 'vue'
import {
  ref,
  defineAsyncComponent,
  onBeforeMount,
  getCurrentInstance,
} from "vue";
import { useRoute, useRouter } from "vue-router/composables";
import { fetch } from "@/plugins/fetchPlugin";

import { useOperationStore } from "@/stores/operation";
interface Submission {
  _id?: string;
  parentSubmissionId?: string;
  lang?: string;
  quantity?: string;
  email?: string;
}

interface Form {
  _id: string;
  type: string;
  lang: string;
  line_item: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'StatusView',
  setup(__props) {

const operationStore = useOperationStore();
const op = ref(operationStore.operationData);

const route = useRoute();
const router = useRouter();
const currentVueInstance = getCurrentInstance();
const DynamicComponent = ref();
const submissionId = ref<string>(route.params.submissionId);
const uid = ref<string>(route.params.uid);
const realSubId = ref<string | undefined>(undefined);
const formId = ref<string | undefined>(undefined);

const vueIsAvailable = async (idgame: string) => {
  try {
    await import(`@/views/idgames/${idgame}/StatusView.vue`);
    return true;
  } catch (error) {
    return false;
  }
};

const getComponentByDomain = async (idgame: string) => {
  let folder = "default";

  const exist = await vueIsAvailable(idgame);
  if (exist) {
    folder = idgame;
  }
  return defineAsyncComponent({
    loader: () => {
      return import(`@/views/idgames/${folder}/StatusView.vue`);
    },
    delay: 1000,
  });
};

const submission = ref<Submission | null>(null);

onBeforeMount(async () => {
  try {
    if (!op.value || !op.value.idgame || !submissionId.value || !uid) {
      router.push("/404");
      return;
    }

    if (Array.isArray(op.value.forms) && op.value.forms.length > 0) {
      const form = op.value.forms.filter((form: Form) => form.line_item);
      if (form && form.length > 0) {
        formId.value = form[0]._id;
      }
    }

    const response = await fetch(
      `/api/v2/submissions/parentSubmission/${submissionId.value}/${uid.value}`
    );

    if (!response) {
      router.push("/404");
      return;
    }

    submission.value = response;
    const lang = submission?.value?.lang || "fr";

    if (currentVueInstance && currentVueInstance.proxy) {
      currentVueInstance.proxy.$i18n.locale = lang;
    }

    if (!submission.value) {
      router.push("/404");
      return;
    }

    realSubId.value =
      submission.value?.parentSubmissionId || submission.value?._id;

    if (realSubId.value) {
      localStorage.setItem("realSubId", realSubId.value);
      localStorage.setItem("uid", uid.value);
    }

    DynamicComponent.value = await getComponentByDomain(op.value.idgame);
  } catch (e) {
    console.error(e);
  }
});

return { __sfc: true,operationStore, op, route, router, currentVueInstance, DynamicComponent, submissionId, uid, realSubId, formId, vueIsAvailable, getComponentByDomain, submission }
}

})